import { render, staticRenderFns } from "./DollarIconLarge.vue?vue&type=template&id=4517e9d2&"
import script from "./DollarIconLarge.vue?vue&type=script&lang=js&"
export * from "./DollarIconLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports